import React, { Component } from 'react';
import Diagram from "../../Diagram/PrognosIntäkter";
import IntlMessages from 'util/IntlMessages';

export default class PrognosIntäkter extends Component {
    render() {
        return (
            <div className="text-center">
                <div>
                    <h2 style={{ paddingTop: '12px', color:'white' }}><b><IntlMessages id="Date.Forecast"/></b></h2>
                </div>
                <div>
                    <Diagram />
                </div>
            </div>
        )
    }
}
